import * as actionTypes from './actionTypes';

export const getProfile = () => ({
    type: actionTypes.GET_PROFILE
});

export const getProfileSucceeded = (payload) => ({
    type: actionTypes.GET_PROFILE_SUCCEEDED,
    payload
});

export const updateProfile = profile => ({
    type: actionTypes.UPDATE_PROFILE,
    profile
});

export const updateProfileSucceeded = (profile) => ({
    type: actionTypes.UPDATE_PROFILE_SUCCEEDED,
    profile
});

export const updateProfileFailed = (validationErrors) => ({
    type: actionTypes.UPDATE_PROFILE_FAILED,
    validationErrors
});

export const updateSettings = ({locale, pushEnabled, mailEnabled, feedbackEnabled}) => ({
    type: actionTypes.UPDATE_SETTINGS,
    settings: {
        locale,
        pushEnabled,
        mailEnabled,
        feedbackEnabled
    }
});

export const updateSettingsSucceeded = (settings) => ({
    type: actionTypes.UPDATE_SETTINGS_SUCCEEDED,
    settings
});

export const updateAvatar = (avatar) => ({
    type: actionTypes.UPDATE_AVATAR,
    avatar
});

export const updateAvatarSucceeded = (avatar) => ({
    type: actionTypes.UPDATE_AVATAR_SUCCEEDED,
    avatar
});

export const loadingNewAvatarDone = () => ({
    type: actionTypes.LOADING_NEW_AVATAR_DONE
});

export const changePassword = (currentPassword, newPassword) => ({
    type: actionTypes.CHANGE_PASSWORD,
    currentPassword,
    newPassword
});

export const changePasswordFailed = validationErrors => ({
    type: actionTypes.CHANGE_PASSWORD_FAILED,
    validationErrors
});